/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
  error: "",
};

const preArrivalPreferenceSlice = createSlice({
  name: "preArrivalPreference",
  initialState,
  reducers: {
    fetchPreArrivalPreference: (state) => {
      state.error = "";
    },

    fetchPreArrivalPreferenceFulfilled: (state, { payload }) => {
      state.data = payload;
      state.error = "";
    },

    fetchPreArrivalPreferenceFailed: (state, { payload: { error } }) => {
      state.data = [];
      state.error = error;
    },

    fetchPreArrivalPreferenceCancel: () => {},

    updatePreArrivalPreference: (state) => {
      state.isUpdating = true;
      state.error = "";
    },

    updatePreArrivalPreferenceFulfilled: (state, { payload }) => {
      state.data = payload;
      state.isUpdating = false;
      state.error = "";
    },

    updatePreArrivalPreferenceFailed: (state, { payload: { error } }) => {
      state.isUpdating = false;
      state.error = error;
    },

    updatePreArrivalPreferenceCancel: (state) => {
      state.isUpdating = false;
    },
  },
});

export const {
  fetchPreArrivalPreference,
  fetchPreArrivalPreferenceFulfilled,
  fetchPreArrivalPreferenceFailed,
  fetchPreArrivalPreferenceCancel,

  updatePreArrivalPreference,
  updatePreArrivalPreferenceFulfilled,
  updatePreArrivalPreferenceFailed,
  updatePreArrivalPreferenceCancel,
} = preArrivalPreferenceSlice.actions;

export default preArrivalPreferenceSlice.reducer;
